import { useWebsite } from 'hooks/website/useWebsite';

import s from './CanvasPreviewImage.module.css';

export const CanvasPreviewImage = () => {
  const {
    home: {
      hero: { image: heroImageSrc },
    },
  } = useWebsite();

  return (
    <div
      role="img"
      title="Classic Image Preview"
      className={s.image}
      style={{
        backgroundImage: `url(${heroImageSrc})`,
      }}
    />
  );
};
